// Complete File - OrderList redesigned to match WarrantyList UI - Imran Khan
import React, { useEffect, useRef, useState, useMemo } from "react";
import {
  Button,
  Col,
  Container,
  Row,
  Spinner,
  Table,
  Form,
  Modal,
  FormGroup,
  FormLabel,
} from "react-bootstrap";
import {
  DatatableWrapper,
  Filter,
  Pagination,
  PaginationOptions,
  TableBody,
  TableHeader,
} from "react-bs-datatable";
import Select from "react-select";
import { Link, useNavigate } from "react-router-dom";
import { isMobile, BrowserView } from "react-device-detect";
import fuziElevatorsApi from "../../api/fuziElevatorsApi";
import { ROUTES } from "../../constants/webRouting";
import DateRangePicker from "rsuite/DateRangePicker";
import "rsuite/DateRangePicker/styles/index.css";
import ".././../assets/css/ListComponentsTable.css";
import {
  formatDate,
  formatDateForView,
  getUserDetails,
} from "../../utils/helper";
import * as Constant from "../../constants/CONSTANT";
import PERMISSIONS from "../../constants/permissions";
import PubSub from "pubsub-js";
import UserMultiSelect from "../common/UserMultiSelect";
import moment from "moment";

/* ─── Inline Styles (same pattern as WarrantyList) ─── */
const styles = `
  @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600&family=Space+Grotesk:wght@400;500;600;700&display=swap');

  * { box-sizing: border-box; }

  .ord-root {
    background: #f0f4f9;
    min-height: 100vh;
    padding: 20px 16px;
    font-family: 'DM Sans', sans-serif;
  }

  .ord-page-title { font-size: 20px; font-weight: 600; color: #1a1d23; margin-bottom: 2px; font-family: 'Space Grotesk', sans-serif; }
  .ord-breadcrumb { font-size: 12px; color: #9098a9; margin-bottom: 3px; }
  .ord-breadcrumb a { color: #378ADD; text-decoration: none; }
  .ord-page-desc { font-size: 12px; color: #b0b8c8; margin-bottom: 20px; }

  /* ── Stat Cards Grid ── */
  .ord-stat-grid {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 12px;
    margin-bottom: 20px;
  }
  @media (max-width: 1400px) { .ord-stat-grid { grid-template-columns: repeat(3, 1fr); } }
  @media (max-width: 768px)  { .ord-stat-grid { grid-template-columns: repeat(2, 1fr); gap: 8px; } }
  @media (max-width: 480px)  { .ord-stat-grid { grid-template-columns: 1fr 1fr; gap: 8px; } }

  .ord-stat-card {
    background: #fff;
    border: 1px solid #e8edf5;
    border-radius: 14px;
    padding: 14px 14px 10px;
    cursor: pointer;
    transition: box-shadow .18s, transform .18s, border-color .18s;
    position: relative;
    overflow: hidden;
  }
  .ord-stat-card:hover {
    box-shadow: 0 6px 24px rgba(55,138,221,.13);
    transform: translateY(-2px);
    border-color: #c8d8ee;
  }
  .ord-stat-card::before {
    content: '';
    position: absolute;
    top: 0; left: 0; right: 0;
    height: 3px;
    border-radius: 14px 14px 0 0;
    background: var(--accent-color, #378ADD);
    opacity: 0;
    transition: opacity .2s;
  }
  .ord-stat-card:hover::before { opacity: 1; }
  .ord-stat-icon {
    width: 34px; height: 34px; border-radius: 9px;
    display: flex; align-items: center; justify-content: center;
    margin-bottom: 10px;
  }
  .ord-stat-label { font-size: 10px; font-weight: 600; color: #9098a9; text-transform: uppercase; letter-spacing: .05em; margin-bottom: 4px; }
  .ord-stat-num   { font-size: 22px; font-weight: 700; line-height: 1; margin-bottom: 3px; font-family: 'Space Grotesk', sans-serif; }
  .ord-stat-sub   { font-size: 10px; color: #b0b8c8; }
  .ord-sparkline  { margin-top: 8px; width: 100%; height: 26px; }

  /* ── Insights ── */
  .ord-insights-title {
    font-size: 13px; font-weight: 600; color: #1a1d23;
    margin-bottom: 12px; display: flex; align-items: center; gap: 7px;
    font-family: 'Space Grotesk', sans-serif;
  }
  .ord-insights-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 12px;
    margin-bottom: 20px;
  }
  @media (max-width: 1200px) { .ord-insights-grid { grid-template-columns: repeat(2, 1fr); } }
  @media (max-width: 640px)  { .ord-insights-grid { grid-template-columns: 1fr; } }

  .ord-insight-card { background: #fff; border: 1px solid #e8edf5; border-radius: 14px; overflow: hidden; }
  .ord-insight-card-head {
    padding: 11px 15px; font-size: 10px; font-weight: 700;
    color: #9098a9; text-transform: uppercase; letter-spacing: .07em;
    border-bottom: 1px solid #f0f4f9; background: #fafbfd;
  }
  .ord-insight-card-body { padding: 14px 15px; }

  /* ── Filter Card ── */
  .ord-filter-card {
    background: #fff; border: 1px solid #e8edf5;
    border-radius: 14px; padding: 16px 18px; margin-bottom: 12px;
  }
  .ord-filter-label {
    font-size: 10px; font-weight: 700; color: #9098a9;
    text-transform: uppercase; letter-spacing: .05em;
    margin-bottom: 5px; display: block;
  }
  .ord-filter-select {
    border: 1px solid #dde3ef; border-radius: 8px; padding: 7px 10px;
    font-size: 12px; color: #333; background: #fff; width: 100%;
    outline: none; transition: border-color .15s; font-family: 'DM Sans', sans-serif;
  }
  .ord-filter-select:focus { border-color: #378ADD; }
  .ord-advanced-toggle {
    font-size: 12px; color: #378ADD; cursor: pointer;
    display: inline-flex; align-items: center; gap: 5px;
    margin-top: 10px; user-select: none; padding: 0;
    background: none; border: none; font-family: 'DM Sans', sans-serif;
    transition: opacity .15s;
  }
  .ord-advanced-toggle:hover { opacity: .75; }

  /* ── Buttons ── */
  .ord-btn-primary {
    background: #378ADD; border: none; border-radius: 8px;
    padding: 7px 14px; font-size: 12px; color: #fff; cursor: pointer;
    font-weight: 600; display: inline-flex; align-items: center; gap: 5px;
    white-space: nowrap; transition: background .15s, transform .12s;
    font-family: 'DM Sans', sans-serif;
  }
  .ord-btn-primary:hover { background: #2a6eb8; transform: translateY(-1px); }
  .ord-btn-secondary {
    background: #f0f4f9; border: 1px solid #dde3ef; border-radius: 8px;
    padding: 7px 12px; font-size: 12px; color: #555; cursor: pointer;
    display: inline-flex; align-items: center; gap: 5px; white-space: nowrap;
    transition: background .15s; font-family: 'DM Sans', sans-serif;
  }
  .ord-btn-secondary:hover { background: #e0e8f4; }

  /* ── Table Card ── */
  .ord-table-card { background: #fff; border: 1px solid #e8edf5; border-radius: 14px; overflow: hidden; margin-bottom: 12px; }
  .ord-table-head {
    display: flex; align-items: center; justify-content: space-between;
    padding: 13px 18px; border-bottom: 1px solid #f0f4f9; flex-wrap: wrap; gap: 8px;
  }
  .ord-table-title { font-size: 14px; font-weight: 600; color: #1a1d23; font-family: 'Space Grotesk', sans-serif; }
  .ord-table-count { font-size: 12px; color: #9098a9; font-weight: 400; margin-left: 4px; }
  .ord-table-scroll { overflow-x: auto; -webkit-overflow-scrolling: touch; }
  .ord-table-foot {
    padding: 10px 18px; border-top: 1px solid #f0f4f9;
    display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 8px;
  }
  .ord-table-foot-text { font-size: 12px; color: #9098a9; }

  /* ── Amount Summary Bar ── */
  .ord-amount-bar {
    display: flex; gap: 10px; flex-wrap: wrap; padding: 10px 14px;
    background: #f7faff; border-bottom: 1px solid #e8edf5; align-items: center;
  }
  .ord-amount-chip {
    display: flex; align-items: center; gap: 6px;
    background: #fff; border: 1px solid #dde3ef;
    border-radius: 8px; padding: 5px 12px;
  }
  .ord-amount-chip-label { font-size: 11px; color: #9098a9; font-weight: 500; }
  .ord-amount-chip-val   { font-size: 13px; font-weight: 700; font-family: 'Space Grotesk', sans-serif; }

  /* ── Progress ── */
  .ord-progress-track { height: 5px; background: #f0f4f9; border-radius: 3px; }
  .ord-progress-fill  { height: 5px; border-radius: 3px; transition: width .4s ease; }

  .ord-donut-wrap { display: flex; align-items: center; gap: 12px; flex-wrap: wrap; }

  .ord-retention-row {
    display: flex; align-items: center; gap: 10px;
    padding: 8px 4px; border-bottom: 1px solid #f0f4f9;
    cursor: pointer; transition: background .12s; border-radius: 6px;
  }
  .ord-retention-row:hover { background: #f7fafd; }
  .ord-retention-row:last-child { border-bottom: none; }

  .ord-legend-pill { font-size: 10px; font-weight: 600; padding: 2px 7px; border-radius: 999px; white-space: nowrap; }

  .ord-filter-row { display: flex; flex-wrap: wrap; gap: 10px; align-items: flex-end; }
  .ord-filter-col    { min-width: 120px; flex: 1 1 120px; }
  .ord-filter-col-lg { min-width: 180px; flex: 2 1 180px; }
  .ord-filter-col-sm { min-width: 90px;  flex: 1 1 90px;  }
  .ord-filter-actions { display: flex; gap: 6px; flex-wrap: wrap; align-items: flex-end; flex: 0 0 auto; }

  @media (max-width: 576px) {
    .ord-filter-col, .ord-filter-col-lg, .ord-filter-col-sm { flex: 1 1 100%; }
    .ord-filter-actions { width: 100%; }
    .ord-table-head { padding: 10px 12px; }
    .ord-filter-card { padding: 12px; }
    .ord-insight-card-body { padding: 10px 12px; }
    .ord-stat-num { font-size: 18px; }
    .ord-stat-card { padding: 12px 10px 8px; }
  }
`;

/* ─── Status config for stat cards ─── */
const ORDER_STATUS_CONFIG = [
  {
    label: "Order Work in Progress",
    color: "#1E90FF",
    iconBg: "#E3F0FF",
    iconColor: "#0A5DB5",
    fa: "fa-solid fa-gear",
  },
  {
    label: "Order Work Complete",
    color: "#eb0c61",
    iconBg: "#FCE3EE",
    iconColor: "#9B0040",
    fa: "fa-solid fa-circle-check",
  },
  {
    label: "Warranty Running",
    color: "#7851A9",
    iconBg: "#EDE7F6",
    iconColor: "#4A2D7A",
    fa: "fa-solid fa-shield-halved",
  },
  {
    label: "Warranty Lost",
    color: "#476038",
    iconBg: "#E8EDE5",
    iconColor: "#2C3D22",
    fa: "fa-solid fa-shield-xmark",
  },
  //   { label: "AMC Running",            color: "#008080", iconBg: "#E0F2F2", iconColor: "#004D4D", fa: "fa-solid fa-rotate" },
  //   { label: "AMC Lost",               color: "#E24B4A", iconBg: "#FCEBEB", iconColor: "#A32D2D", fa: "fa-solid fa-ban" },
  //   { label: "AMC Direct Order",       color: "#2aada7", iconBg: "#E0F5F5", iconColor: "#1A7570", fa: "fa-solid fa-rocket" },
  //   { label: "One Time",               color: "#9b3131", iconBg: "#F5E5E5", iconColor: "#6B1E1E", fa: "fa-solid fa-calendar-day" },
];

/* ─── Amount formatter ─── */
const fmtAmt = (n) =>
  new Intl.NumberFormat("en-IN", { maximumFractionDigits: 0 }).format(
    Math.round(n || 0),
  );

/* ─── Sparkline SVG ─── */
const Sparkline = ({ color, points }) => (
  <svg
    className="ord-sparkline"
    viewBox="0 0 120 26"
    preserveAspectRatio="none"
  >
    <polyline
      points={points}
      fill="none"
      stroke={color}
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/* ─── Stat Card ─── */
const StatCard = ({
  icon,
  iconBg,
  iconColor,
  label,
  num,
  numColor,
  sub,
  sparkColor,
  sparkPoints,
  onClick,
  accentColor,
}) => (
  <div
    className="ord-stat-card"
    style={{ "--accent-color": accentColor || numColor || "#378ADD" }}
    onClick={onClick}
  >
    <div className="ord-stat-icon" style={{ background: iconBg }}>
      <i className={icon} style={{ fontSize: 14, color: iconColor }}></i>
    </div>
    <div className="ord-stat-label">{label}</div>
    <div className="ord-stat-num" style={{ color: numColor || "#1a1d23" }}>
      {num}
    </div>
    <div className="ord-stat-sub">{sub}</div>
    {sparkPoints && <Sparkline color={sparkColor} points={sparkPoints} />}
  </div>
);

/* ─── Donut Chart ─── */
const DonutChart = ({ data, total }) => {
  const r = 48,
    cx = 56,
    cy = 56,
    circ = 2 * Math.PI * r;
  let offset = 0;
  const slices = data.map((d) => {
    const pct = total > 0 ? d.count / total : 0;
    const dash = pct * circ;
    const slice = { ...d, dash, offset };
    offset += dash;
    return slice;
  });
  return (
    <svg
      width="112"
      height="112"
      viewBox="0 0 112 112"
      style={{ flexShrink: 0 }}
    >
      <circle
        cx={cx}
        cy={cy}
        r={r}
        fill="none"
        stroke="#f0f4f9"
        strokeWidth="14"
      />
      {slices.map((s, i) => (
        <circle
          key={i}
          cx={cx}
          cy={cy}
          r={r}
          fill="none"
          stroke={s.color}
          strokeWidth="14"
          strokeDasharray={`${s.dash} ${circ - s.dash}`}
          strokeDashoffset={circ / 4 - s.offset}
        />
      ))}
      <text
        x={cx}
        y={cy - 5}
        textAnchor="middle"
        fontSize="15"
        fontWeight="700"
        fill="#1a1d23"
        fontFamily="'Space Grotesk', sans-serif"
      >
        {total.toLocaleString("en-IN")}
      </text>
      <text x={cx} y={cy + 10} textAnchor="middle" fontSize="8" fill="#9098a9">
        TOTAL
      </text>
    </svg>
  );
};

/* ────────────────────────────────────────────────
   MAIN COMPONENT
──────────────────────────────────────────────── */
const OrderList = () => {
  const userInfo = getUserDetails();
  const navigate = useNavigate();

  const [body, setBody] = useState();
  const [dateRange, setDateRange] = useState([]);
  const [filterData, setFilterData] = useState({
    order_status: "Order Work in Progress",
  });
  const [products, setLeadsValues] = useState([]);
  const [assignUsers, setAssignUsers] = useState([]);
  const [accounts, setAccounts] = useState([]);
  const [showAdvanced, setShowAdvanced] = useState(false);

  // Transfer Owner
  const [changeOwnerModal, setChangeOwnerModal] = useState(false);
  const [refreshRecords, setRefreshRecords] = useState(false);
  const [ownerLeads, setOwnerLeads] = useState([]);
  const [ownerLeadsHeader, setOwnerLeadsHeader] = useState([]);
  const [fromUser, setFromUser] = useState({});
  const [toUser, setToUser] = useState({});
  const tableRef = useRef(null);
  const [users, setUsers] = useState([]);
  const [spinnerForChangeOwner, setSpinnerForChangeOwner] = useState(false);
  const [selectedToUsers, setSelectedToUsers] = useState([]);

  /* ── Fetch orders when filter/dateRange changes ── */
  useEffect(() => {
    const filter = { ...filterData };
    delete filter.owner_name;
    delete filter.product_name;
    delete filter.lead_name;
    // Handle combined status filter
    if (filter.order_status === "__BOTH__")
      filter.order_status = ["Order Work in Progress", "Order Work Complete"];
    filter.owner_ids = filter?.owner_ids
      ?.filter((i) => i.value)
      ?.map((i) => i.value);
    filter.account_id = filter?.accounts
      ?.filter((i) => i.value)
      ?.map((i) => i.value);
    delete filter.accounts;
    if (Array.isArray(dateRange) && dateRange.length > 0)
      filter.date_range = {
        filed: "createddate",
        createddate: {
          from: formatDate(dateRange?.at(0)),
          to: formatDate(dateRange?.at(1)),
        },
      };
    fetchOrders(filter);
  }, [dateRange, filterData]);

  async function init() {
    if (
      [PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_USER].some((p) =>
        userInfo?.permissions?.map((x) => x.name).includes(p),
      )
    ) {
      const r = await fuziElevatorsApi.fetchUsers();
      r &&
        Array.isArray(r) &&
        setAssignUsers(r.map((u) => ({ value: u.id, label: u.username })));
    }
    const a = await fuziElevatorsApi.fetchAccounts();
    a && Array.isArray(a) && setAccounts(a);
  }

  async function fetchOrders(filters) {
    const result = await fuziElevatorsApi.fetchOrders(filters);
    if (result) {
      setBody(result);
      if (
        Array.isArray(result) &&
        (filters?.offer_id === undefined || filters?.offer_id === null)
      )
        setLeadsValues(
          result.map((r) => ({
            id: r.offer_id,
            name: r.offer_name_label || "",
          })),
        );
    } else {
      setBody([]);
    }
  }

  useEffect(() => {
    init();
  }, []);

  useEffect(() => {
    (async () => {
      try {
        const u = await fuziElevatorsApi.fetchUsersForListPage();
        setUsers(
          Array.isArray(u)
            ? u.map(({ id, username, userrole }) => ({
                value: id,
                label: `${username} - ${userrole}`,
              }))
            : [],
        );
      } catch {
        setUsers([]);
      }
    })();
  }, []);

  /* ── Derived stats from body ── */
  const allRows = Array.isArray(body) ? body : [];
  const total = allRows.length;

  const statusCounts = useMemo(
    () =>
      ORDER_STATUS_CONFIG.reduce((acc, c) => {
        acc[c.label] = allRows.filter((r) => r.order_status === c.label).length;
        return acc;
      }, {}),
    [allRows],
  );

  const statusCards = useMemo(
    () =>
      ORDER_STATUS_CONFIG.filter((c) => statusCounts[c.label] > 0)
        .map((c) => ({ ...c, count: statusCounts[c.label] }))
        .sort((a, b) => b.count - a.count),
    [statusCounts],
  );

  const pct = (n) => (total > 0 ? Math.round((n / total) * 100) : 0);

  /* ── City breakdown ── */
  const cityData = useMemo(() => {
    const counts = allRows.reduce((acc, r) => {
      if (r.city) {
        const k = r.city.trim().toLowerCase();
        acc[k] = (acc[k] || 0) + 1;
      }
      return acc;
    }, {});
    return Object.entries(counts)
      .sort((a, b) => b[1] - a[1])
      .slice(0, 5)
      .map(([city, count]) => ({
        city: city.charAt(0).toUpperCase() + city.slice(1),
        count,
      }));
  }, [allRows]);

  /* ── Amount totals ── */
  const canViewPayment = [PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_PAYMENT].some(
    (p) => userInfo?.permissions?.map((x) => x.name).includes(p),
  );

  const totals = useMemo(
    () =>
      allRows.reduce(
        (acc, row) => {
          const o = Number(row.order_amount || 0);
          const p = Number(row.paid_amount || 0);
          const t = Number(row.tax_amount || 0);
          acc.order_amount += o;
          acc.paid_amount += p;
          acc.due_amount += (o + t) - p;

          return acc;
        },
        { order_amount: 0, paid_amount: 0, due_amount: 0 },
      ),
    [allRows],
  );

  /* ── Status css (for badge in table) ── */
  const getStatusClass = (status) => {
    const s = Constant.ORDER_STATUS_VALUES?.find((v) => v.label === status);
    return s ? s.css : {};
  };

  /* ── Custom filter ── */
  const customFilter = (rows, filters) =>
    rows.filter((row) =>
      Object.keys(filters).every((col) => {
        const fv = filters[col]?.toLowerCase() || "";
        if (!fv) return true;
        return (row[col]?.toString().toLowerCase() || "").includes(fv);
      }),
    );

  /* ── handleChange ── */
  const handleChange = (e) =>
    setFilterData((pre) => ({ ...pre, [e.target.name]: e.target.value }));

  const handleClear = () => {
    setFilterData({});
    fetchOrders({});
  };

  /* ── Table headers ── */
  const header = [];
  if (!isMobile) {
    header.push(
      {
        title: "Offer",
        prop: "offer_name_label",
        isFilterable: true,
        isSortable: true,
        cell: (row) => (
          <Link to={`${ROUTES.ORDER.LIST}/${row.id}`} state={row}>
            {row.offer_name_label}
          </Link>
        ),
      },
      {
        title: "Order Date",
        prop: "order_date",
        isFilterable: true,
        isSortable: true,
        cell: (row) =>
          row?.order_date ? formatDateForView(row.order_date) : "",
      },
      { title: "Site Address", prop: "site_address", isFilterable: true },
      { title: "City", prop: "city", isFilterable: true },
      { title: "Sector", prop: "sector", isFilterable: true },
      {
        title: "Make",
        prop: "accounts",
        isFilterable: true,
        cell: (row) => {
          if (!row.account_id || !Array.isArray(row.account_id)) return null;
          const matched = accounts.filter((a) => row.account_id.includes(a.id));
          return (
            <>
              {matched.map((a, i) => (
                <span key={a.id}>
                  <Link to={`${ROUTES.ACCOUNT.LIST}/${a.id}`}>{a.name}</Link>
                  {i < matched.length - 1 && ", "}
                </span>
              ))}
            </>
          );
        },
      },
      { title: "Lead Type", prop: "leadtype", isFilterable: true },
      {
        title: "Product",
        prop: "product_name",
        isFilterable: true,
        cell: (row) => (
          <Link to={`${ROUTES.PRODUCT.LIST}/${row.product_id}`}>
            {row.product_name}
          </Link>
        ),
      },
      {
        title: "Order Status",
        prop: "order_status",
        isFilterable: true,
        isSortable: true,
        alignment: { horizontal: "center" },
        cell: (row) => (
          <span
            className="badge rounded-pill w-100"
            style={getStatusClass(row.order_status)}
          >
            {row.order_status}
          </span>
        ),
      },
    );
    canViewPayment &&
      header.push(
        { title: "Order Amount", prop: "order_amount", isFilterable: true },
        { title: "Paid Amount", prop: "paid_amount", isFilterable: true },
        {
          title: "Due Amount + Tax",
          prop: "due_amount",
          isFilterable: true,
          cell: (row) =>
            Number(row.order_amount || 0) + Number(row.tax_amount || 0) - Number(row.paid_amount || 0),
        },
      );
  } else {
    header.push({
      title: "Info",
      prop: "offer_name",
      isFilterable: true,
      isSortable: true,
      cell: (row) => (
        <div className="mobilecard">
          <Link
            to={`${ROUTES.ORDER.LIST}/${row.id}`}
            state={row}
            style={{ width: "100%" }}
          >
            {row.offer_name}
          </Link>
          <span>
            <i className="fa-solid fa-phone"></i> {row.phone}
          </span>
          <span style={{ width: "80%" }}>
            <i className="fa-solid fa-envelope"></i> {row.email}
          </span>
        </div>
      ),
    });
  }

  /* ── Transfer Owner handlers ── */
  const handelCheckBox = (e) =>
    [...tableRef.current.querySelectorAll(`input[name='leads']`)].forEach(
      (el) => {
        el.checked = e.target.checked;
      },
    );

  useEffect(() => {
    (async () => {
      if (fromUser?.value) {
        setSpinnerForChangeOwner(true);
        const leads = await fuziElevatorsApi.getOrderByStaffId(fromUser.value);
        if (leads.success) {
          setOwnerLeads(leads.data);
          setOwnerLeadsHeader([
            {
              title: (
                <Form.Check
                  type="checkbox"
                  label="Select All"
                  name="all_leads"
                  onChange={handelCheckBox}
                />
              ),
              prop: "id",
              isFilterable: true,
              cell: (row) => (
                <Form.Check type="checkbox" id={`${row.id}`} name="leads" />
              ),
            },
            {
              title: "Offer",
              prop: "offer_name_label",
              isFilterable: true,
              cell: (row) => (
                <Link to={"/orders/" + row.id} state={row}>
                  {row.offer_name_label}
                </Link>
              ),
            },
            {
              title: "Order Status",
              prop: "order_status",
              isFilterable: true,
              isSortable: true,
            },
            {
              title: "Created Date",
              prop: "createddate",
              isSortable: true,
              isFilterable: true,
              cell: (row) => (
                <span>{moment(row.createddate).format("DD-MM-yyyy")}</span>
              ),
            },
            {
              title: "Assigned",
              prop: "ownername",
              isFilterable: true,
              isSortable: true,
              cell: (row) => {
                const abbr = {
                  "Sales Admin": "S. S.",
                  "Installation Admin": "I. A.",
                  Accounts: "ACCOUNTS",
                  "Accounts Admin": "A. A.",
                  "Installation Engineer": "I. E.",
                  "Installation Supervisor": "I. S.",
                  "Business Development Executive": "B. D. E.",
                  "Customer Relationship Executive": "C. R. E.",
                  Office: "OFFICE",
                  "Office Coordinator": "O. C.",
                  "Office Executive": "O. E.",
                  "Service Admin": "S. R.",
                  SUPER_ADMIN: "SUPER_ADMIN",
                };
                const names = row.ownername ? row.ownername.split(", ") : [];
                const ids = row.ownerid || [];
                const shortenTitle = (name) => {
                  const [fn, title] = name.split(" - ");
                  return `${fn} - ${abbr[title?.trim()] || title}`;
                };
                return (
                  <span>
                    {names.map((n, i) => (
                      <Link
                        key={i}
                        to={`/users/${ids[i]}`}
                        state={row}
                        className="align-items-center justify-content-start"
                      >
                        {shortenTitle(n)}
                        <br />
                      </Link>
                    ))}
                  </span>
                );
              },
            },
          ]);
        } else {
          setOwnerLeads([]);
          setOwnerLeadsHeader([]);
        }
        setSpinnerForChangeOwner(false);
      } else {
        setOwnerLeads([]);
        setOwnerLeadsHeader([]);
      }
    })();
  }, [fromUser]);

  const handelChangeOwnerModalClose = () => {
    setChangeOwnerModal(false);
    setRefreshRecords((r) => !r);
    setOwnerLeads([]);
    setOwnerLeadsHeader([]);
    setFromUser({});
    setToUser({});
    setSelectedToUsers([]);
  };

  const ChangeOwner = (e) => {
    e.preventDefault();
    let leads = [...tableRef?.current?.querySelectorAll(`input[name='leads']`)]
      .filter((el) => el.checked)
      .map((el) => el.id);
    const toUsers = selectedToUsers.map((u) => u.value);
    (async () => {
      const result = await fuziElevatorsApi.ChangeOrderOwner({
        fromUser: fromUser.value,
        toUser: toUsers,
        leads,
      });
      if (result.success) {
        PubSub.publish("RECORD_SAVED_TOAST", {
          title: "Transfer Owner",
          message: "Owner Transfer successfully",
        });
        setSelectedToUsers([]);
        handelChangeOwnerModalClose();
      } else {
        PubSub.publish("RECORD_ERROR_TOAST", {
          title: "Transfer Owner Error",
          message: "Some error occurred",
        });
      }
    })();
  };

  const cityColors = ["#378ADD", "#1D9E75", "#EF9F27", "#7F77DD", "#D85A30"];

  /* ══════════════════════════════════════════════
     RENDER
  ══════════════════════════════════════════════ */
  return (
    <>
      <style>{styles}</style>
      <div className="ord-root">
        {/* ── Page Header ── */}
        {/* <div className="ord-page-title">Order Management</div>
        <div className="ord-breadcrumb">
          <a href="#">Dashboard</a> › Order Management
        </div>
        <div className="ord-page-desc">Manage and track all product orders</div> */}

        {/* ════════════════════════════════════
            STAT CARDS — Row 1 (5 cards)
        ════════════════════════════════════ */}
        {/* <div className="ord-stat-grid">
          <StatCard
            icon="fa-solid fa-layer-group"
            iconBg="#E6F1FB"
            iconColor="#185FA5"
            label="Total Records"
            num={total.toLocaleString("en-IN")}
            numColor="#1a1d23"
            sub="All order records"
            sparkColor="#378ADD"
            sparkPoints="0,22 20,17 40,20 60,12 80,15 100,7 120,11"
            accentColor="#378ADD"
          />
          <StatCard
            icon="fa-solid fa-gear"
            iconBg="#E3F0FF"
            iconColor="#0A5DB5"
            label="Work In Progress"
            num={statusCounts["Order Work in Progress"]?.toLocaleString(
              "en-IN",
            )}
            numColor="#1E90FF"
            sub={`${pct(statusCounts["Order Work in Progress"])}% of total`}
            sparkColor="#1E90FF"
            sparkPoints="0,20 20,16 40,18 60,10 80,14 100,6 120,9"
            accentColor="#1E90FF"
            onClick={() =>
              setFilterData((p) => ({
                ...p,
                order_status: "Order Work in Progress",
              }))
            }
          />
          <StatCard
            icon="fa-solid fa-circle-check"
            iconBg="#FCE3EE"
            iconColor="#9B0040"
            label="Work Complete"
            num={statusCounts["Order Work Complete"]?.toLocaleString("en-IN")}
            numColor="#eb0c61"
            sub={`${pct(statusCounts["Order Work Complete"])}% of total`}
            sparkColor="#eb0c61"
            sparkPoints="0,18 20,14 40,20 60,12 80,16 100,8 120,12"
            accentColor="#eb0c61"
            onClick={() =>
              setFilterData((p) => ({
                ...p,
                order_status: "Order Work Complete",
              }))
            }
          />
          <StatCard
            icon="fa-solid fa-shield-halved"
            iconBg="#EDE7F6"
            iconColor="#4A2D7A"
            label="Warranty Running"
            num={statusCounts["Warranty Running"]?.toLocaleString("en-IN")}
            numColor="#7851A9"
            sub={`${pct(statusCounts["Warranty Running"])}% of total`}
            sparkColor="#7851A9"
            sparkPoints="0,20 20,15 40,17 60,9 80,11 100,4 120,8"
            accentColor="#7851A9"
            onClick={() =>
              setFilterData((p) => ({ ...p, order_status: "Warranty Running" }))
            }
          />
          <StatCard
            icon="fa-solid fa-shield-xmark"
            iconBg="#E8EDE5"
            iconColor="#2C3D22"
            label="Warranty Lost"
            num={statusCounts["Warranty Lost"]?.toLocaleString("en-IN")}
            numColor="#476038"
            sub={`${pct(statusCounts["Warranty Lost"])}% of total`}
            sparkColor="#476038"
            sparkPoints="0,22 20,22 40,20 60,22 80,20 100,18 120,14"
            accentColor="#476038"
            onClick={() =>
              setFilterData((p) => ({ ...p, order_status: "Warranty Lost" }))
            }
          />
        </div> */}

        {/* ════════════════════════════════════
            STAT CARDS — Row 2 (4 cards + amount cards)
        ════════════════════════════════════ */}
        {/* </div><div className="ord-stat-grid"> */}
          {/* <StatCard
            icon="fa-solid fa-rotate"
            iconBg="#E0F2F2" iconColor="#004D4D"
            label="AMC Running"
            num={statusCounts["AMC Running"]?.toLocaleString("en-IN")}
            numColor="#008080"
            sub={`${pct(statusCounts["AMC Running"])}% of total`}
            sparkColor="#008080"
            sparkPoints="0,18 20,14 40,20 60,11 80,15 100,7 120,11"
            accentColor="#008080"
            onClick={() => setFilterData((p) => ({ ...p, order_status: "AMC Running" }))}
          /> */}
          {/* <StatCard
            icon="fa-solid fa-ban"
            iconBg="#FCEBEB" iconColor="#A32D2D"
            label="AMC Lost"
            num={statusCounts["AMC Lost"]?.toLocaleString("en-IN")}
            numColor="#E24B4A"
            sub={`${pct(statusCounts["AMC Lost"])}% of total`}
            sparkColor="#E24B4A"
            sparkPoints="0,22 20,20 40,22 60,20 80,18 100,16 120,12"
            accentColor="#E24B4A"
            onClick={() => setFilterData((p) => ({ ...p, order_status: "AMC Lost" }))}
          />
          <StatCard
            icon="fa-solid fa-rocket"
            iconBg="#E0F5F5" iconColor="#1A7570"
            label="AMC Direct Order"
            num={statusCounts["AMC Direct Order"]?.toLocaleString("en-IN")}
            numColor="#2aada7"
            sub={`${pct(statusCounts["AMC Direct Order"])}% of total`}
            sparkColor="#2aada7"
            sparkPoints="0,16 20,12 40,18 60,10 80,14 100,6 120,10"
            accentColor="#2aada7"
            onClick={() => setFilterData((p) => ({ ...p, order_status: "AMC Direct Order" }))}
          />
          <StatCard
            icon="fa-solid fa-calendar-day"
            iconBg="#F5E5E5" iconColor="#6B1E1E"
            label="One Time"
            num={statusCounts["One Time"]?.toLocaleString("en-IN")}
            numColor="#9b3131"
            sub={`${pct(statusCounts["One Time"])}% of total`}
            sparkColor="#9b3131"
            sparkPoints="0,20 20,16 40,22 60,14 80,18 100,10 120,14"
            accentColor="#9b3131"
            onClick={() => setFilterData((p) => ({ ...p, order_status: "One Time" }))}
          /> */}
          {/* Amount cards — only if permission */}
          {/* {canViewPayment && (
            <>
              <div
                className="ord-stat-card"
                style={{ "--accent-color": "#1a56db", cursor: "default" }}
              >
                <div
                  className="ord-stat-icon"
                  style={{ background: "#E6F1FB" }}
                >
                  <i
                    className="fa-solid fa-indian-rupee-sign"
                    style={{ fontSize: 14, color: "#185FA5" }}
                  ></i>
                </div>
                <div className="ord-stat-label">Order Amount</div>
                <div
                  className="ord-stat-num"
                  style={{ color: "#1a56db", fontSize: 16 }}
                >
                  ₹{fmtAmt(totals.order_amount)}
                </div>
                <div className="ord-stat-sub">All visible records</div>
              </div>
              <div
                className="ord-stat-card"
                style={{ "--accent-color": "#057a55", cursor: "default" }}
              >
                <div
                  className="ord-stat-icon"
                  style={{ background: "#E0F2F2" }}
                >
                  <i
                    className="fa-solid fa-circle-check"
                    style={{ fontSize: 14, color: "#057a55" }}
                  ></i>
                </div>
                <div className="ord-stat-label">Paid / Due</div>
                <div
                  className="ord-stat-num"
                  style={{ color: "#057a55", fontSize: 15 }}
                >
                  ₹{fmtAmt(totals.paid_amount)}
                </div>
                <div
                  className="ord-stat-sub"
                  style={{
                    color: totals.due_amount > 0 ? "#e3342f" : "#057a55",
                    fontWeight: 600,
                  }}
                >
                  ₹{fmtAmt(totals.due_amount)} due
                </div>
              </div>
            </>
          )}
        </div> */}

        {/* ════════════════════════════════════
            INSIGHTS SECTION
        ════════════════════════════════════ */}
        {body && Array.isArray(body) && total > 0 && (
          <>
            <div className="ord-insights-title">
              <i
                className="fa-solid fa-chart-pie"
                style={{ color: "#378ADD", fontSize: 13 }}
              ></i>
              Order Insights
            </div>
            <div className="ord-insights-grid">
              {/* Status Breakdown Donut */}
              <div className="ord-insight-card">
                <div className="ord-insight-card-head">Status Breakdown</div>
                <div className="ord-insight-card-body">
                  <div className="ord-donut-wrap">
                    <DonutChart data={statusCards} total={total} />
                    <div style={{ flex: 1, minWidth: 0 }}>
                      {statusCards.map(({ label, color, count }) => (
                        <div
                          key={label}
                          onClick={() =>
                            setFilterData((p) => ({
                              ...p,
                              order_status: label,
                            }))
                          }
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 7,
                            fontSize: 11,
                            color: "#555",
                            marginBottom: 7,
                            cursor: "pointer",
                          }}
                        >
                          <span
                            style={{
                              width: 8,
                              height: 8,
                              borderRadius: "50%",
                              background: color,
                              flexShrink: 0,
                            }}
                          ></span>
                          <span
                            style={{
                              flex: 1,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {label}
                          </span>
                          <strong
                            style={{
                              color: "#1a1d23",
                              fontFamily: "'Space Grotesk', sans-serif",
                            }}
                          >
                            {count.toLocaleString("en-IN")}
                          </strong>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>

              {/* Top Cities */}
              {cityData.length > 0 && (
                <div className="ord-insight-card">
                  <div className="ord-insight-card-head">Top Cities</div>
                  <div className="ord-insight-card-body">
                    {cityData.map(({ city, count }, idx) => {
                      const p =
                        cityData[0].count > 0
                          ? Math.round((count / cityData[0].count) * 100)
                          : 0;
                      const c = cityColors[idx];
                      return (
                        <div key={city} style={{ marginBottom: 10 }}>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              fontSize: 12,
                              color: "#555",
                              marginBottom: 4,
                              alignItems: "center",
                            }}
                          >
                            <span
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: 6,
                              }}
                            >
                              <span
                                className="ord-legend-pill"
                                style={{ color: c, background: c + "18" }}
                              >
                                #{idx + 1}
                              </span>
                              {city}
                            </span>
                            <strong
                              style={{
                                color: "#1a1d23",
                                fontFamily: "'Space Grotesk', sans-serif",
                              }}
                            >
                              {count}
                            </strong>
                          </div>
                          <div
                            className="ord-progress-track"
                            style={{ height: 4 }}
                          >
                            <div
                              className="ord-progress-fill"
                              style={{
                                width: `${p}%`,
                                background: c,
                                height: 4,
                              }}
                            />
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}

              {/* Order Overview */}
              <div className="ord-insight-card">
                <div className="ord-insight-card-head">Order Overview</div>
                <div
                  className="ord-insight-card-body"
                  style={{ padding: "8px 14px" }}
                >
                  {[
                    {
                      label: "Order Work in Progress",
                      count: statusCounts["Order Work in Progress"],
                      color: "#1E90FF",
                      icon: "fa-solid fa-gear",
                    },
                    {
                      label: "Order Work Complete",
                      count: statusCounts["Order Work Complete"],
                      color: "#eb0c61",
                      icon: "fa-solid fa-circle-check",
                    },
                    {
                      label: "Warranty Running",
                      count: statusCounts["Warranty Running"],
                      color: "#7851A9",
                      icon: "fa-solid fa-shield-halved",
                    },
                    {
                      label: "Warranty Lost",
                      count: statusCounts["Warranty Lost"],
                      color: "#476038",
                      icon: "fa-solid fa-shield-xmark",
                    },
                    // { label: "AMC Running",      count: statusCounts["AMC Running"],            color: "#008080", icon: "fa-solid fa-rotate" },
                    // { label: "AMC Lost",         count: statusCounts["AMC Lost"],               color: "#E24B4A", icon: "fa-solid fa-ban" },
                  ].map(({ label, count, color, icon }) => (
                    <div
                      key={label}
                      className="ord-retention-row"
                      onClick={() =>
                        setFilterData((p) => ({ ...p, order_status: label }))
                      }
                    >
                      <div
                        style={{
                          width: 28,
                          height: 28,
                          borderRadius: "50%",
                          background: color + "18",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          flexShrink: 0,
                        }}
                      >
                        <i className={icon} style={{ fontSize: 12, color }}></i>
                      </div>
                      <span style={{ flex: 1, fontSize: 12, color: "#555" }}>
                        {label}
                      </span>
                      <span
                        style={{
                          fontSize: 14,
                          fontWeight: 700,
                          color,
                          fontFamily: "'Space Grotesk', sans-serif",
                        }}
                      >
                        {count?.toLocaleString("en-IN")}
                      </span>
                      <span
                        style={{
                          fontSize: 10,
                          color: "#b0b8c8",
                          minWidth: 28,
                          textAlign: "right",
                        }}
                      >
                        {pct(count)}%
                      </span>
                    </div>
                  ))}
                </div>
              </div>

              {/* Amount Summary (permission-gated) */}
              {canViewPayment && (
                <div className="ord-insight-card">
                  <div className="ord-insight-card-head">Amount Summary</div>
                  <div
                    className="ord-insight-card-body"
                    style={{ padding: "8px 14px" }}
                  >
                    {[
                      {
                        label: "Order Amount",
                        amount: totals.order_amount,
                        color: "#1a56db",
                        icon: "fa-solid fa-file-invoice-dollar",
                      },
                      {
                        label: "Paid Amount",
                        amount: totals.paid_amount,
                        color: "#057a55",
                        icon: "fa-solid fa-circle-check",
                      },
                      {
                        label: "Due Amount",
                        amount: totals.due_amount,
                        color: totals.due_amount > 0 ? "#e3342f" : "#057a55",
                        icon: "fa-solid fa-clock",
                      },
                    ].map(({ label, amount, color, icon }) => (
                      <div
                        key={label}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 10,
                          padding: "10px 0",
                          borderBottom: "1px solid #f0f4f9",
                        }}
                      >
                        <div
                          style={{
                            width: 28,
                            height: 28,
                            borderRadius: "50%",
                            background: color + "18",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexShrink: 0,
                          }}
                        >
                          <i
                            className={icon}
                            style={{ fontSize: 12, color }}
                          ></i>
                        </div>
                        <span style={{ flex: 1, fontSize: 12, color: "#555" }}>
                          {label}
                        </span>
                        <span
                          style={{
                            fontSize: 13,
                            fontWeight: 700,
                            color,
                            fontFamily: "'Space Grotesk', sans-serif",
                          }}
                        >
                          ₹{fmtAmt(amount)}
                        </span>
                      </div>
                    ))}
                    <div style={{ marginTop: 12 }}>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          fontSize: 11,
                          color: "#9098a9",
                          marginBottom: 5,
                        }}
                      >
                        <span>Collection Rate</span>
                        <span>
                          {totals.order_amount > 0
                            ? Math.round(
                                (totals.paid_amount / totals.order_amount) *
                                  100,
                              )
                            : 0}
                          %
                        </span>
                      </div>
                      <div className="ord-progress-track">
                        <div
                          className="ord-progress-fill"
                          style={{
                            width: `${totals.order_amount > 0 ? Math.round((totals.paid_amount / totals.order_amount) * 100) : 0}%`,
                            background: "#057a55",
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </>
        )}

        {/* ════════════════════════════════════
            DATATABLE SECTION
        ════════════════════════════════════ */}
        <Container fluid style={{ padding: 0 }}>
          <DatatableWrapper
            body={body && Array.isArray(body) ? body : []}
            headers={header}
            paginationOptionsProps={{
              initialState: {
                rowsPerPage: 50,
                options: [5, 10, 15, 20, 30, 50],
              },
            }}
            sortProps={{ initialState: { prop: "order_date", order: "desc" } }}
            filterFunction={customFilter}
          >
            {/* ── Filter Card ── */}
            <div className="ord-filter-card">
              <div className="ord-filter-row">
                {/* Search */}
                <div className="ord-filter-col-lg">
                  <label className="ord-filter-label">Search</label>
                  <Filter
                    classes={{
                      inputGroup: "",
                      input: "",
                      clearButton: "btn-custom",
                    }}
                  />
                </div>

                {/* Order Status */}
                <div className="ord-filter-col">
                  <label className="ord-filter-label">Order Status</label>
                  <Form.Select
                    name="order_status"
                    value={filterData?.order_status || ""}
                    onChange={handleChange}
                    className="ord-filter-select"
                  >
                    {/* <option value="">All Status</option>
                    <optgroup label="── Work Status ──">
                      <option value="Order Work in Progress">
                        Order Work in Progress
                      </option>
                      <option value="Order Work Complete">
                        Order Work Complete
                      </option>
                      <option value="__BOTH__">
                        Work in Progress + Work Complete
                      </option>
                    </optgroup> */}
                    <optgroup label="── All Statuses ──">
                      {Constant.ORDER_STATUS_VALUES?.map((s, i) => (
                        <option key={i} value={s.label}>
                          {s.label}
                        </option>
                      ))}
                    </optgroup>
                  </Form.Select>
                </div>

                {/* Assigned User */}
                <div className="ord-filter-col-lg">
                  <label className="ord-filter-label">Assigned To</label>
                  <Select
                    isMulti
                    name="owner_ids"
                    classNamePrefix="react-select"
                    className="z-3"
                    onChange={(e) =>
                      handleChange({ target: { name: "owner_ids", value: e } })
                    }
                    value={filterData?.owner_ids?.filter((i) => i.value)}
                    options={assignUsers}
                    styles={{
                      control: (b) => ({
                        ...b,
                        fontSize: 12,
                        minHeight: 36,
                        borderRadius: 8,
                        borderColor: "#dde3ef",
                      }),
                    }}
                  />
                </div>

                {/* Per Page */}
                <div className="ord-filter-col-sm">
                  <label className="ord-filter-label">Per Page</label>
                  <PaginationOptions labels={{ beforeSelect: " " }} />
                </div>

                {/* Action Buttons */}
                <div className="ord-filter-actions">
                  <button className="ord-btn-secondary" onClick={handleClear}>
                    <i className="fa fa-refresh" style={{ fontSize: 10 }}></i>{" "}
                    Reset
                  </button>
                  {[PERMISSIONS.MODIFY_ALL, PERMISSIONS?.MODIFY_ORDER].some(
                    (p) =>
                      userInfo?.permissions?.map((x) => x.name).includes(p),
                  ) && (
                    <button
                      className="ord-btn-primary"
                      onClick={() => navigate(ROUTES.ORDER.CREATE)}
                    >
                      <i
                        className="fa-solid fa-plus"
                        style={{ fontSize: 10 }}
                      ></i>{" "}
                      New Order
                    </button>
                  )}
                  {userInfo?.userrole === "SUPER_ADMIN" && (
                    <button
                      className="ord-btn-primary"
                      style={{ background: "#7F77DD" }}
                      onClick={() => setChangeOwnerModal(true)}
                    >
                      <i
                        className="fa-solid fa-shuffle"
                        style={{ fontSize: 10 }}
                      ></i>{" "}
                      Transfer
                    </button>
                  )}
                </div>
              </div>

              {/* Advanced Filters toggle */}
              <button
                className="ord-advanced-toggle"
                onClick={() => setShowAdvanced((p) => !p)}
              >
                <i
                  className={`fa-solid fa-chevron-${showAdvanced ? "down" : "right"}`}
                  style={{ fontSize: 9 }}
                ></i>
                Advanced Filters
              </button>

              {showAdvanced && (
                <div className="ord-filter-row" style={{ marginTop: 12 }}>
                  {/* Offer dropdown */}
                  <div className="ord-filter-col-lg">
                    <label className="ord-filter-label">Offer</label>
                    <Select
                      placeholder="Select Offer"
                      classNamePrefix="react-select"
                      className="z-3"
                      isClearable
                      options={products.map((p) => ({
                        value: p.id,
                        label: p.name,
                      }))}
                      onChange={(e) => {
                        handleChange({
                          target: { name: "offer_id", value: e?.value || "" },
                        });
                        handleChange({
                          target: { name: "lead_name", value: e?.label || "" },
                        });
                      }}
                      value={
                        filterData?.offer_id
                          ? {
                              value: filterData.offer_id,
                              label: filterData.lead_name,
                            }
                          : null
                      }
                      styles={{
                        control: (b) => ({
                          ...b,
                          fontSize: 12,
                          minHeight: 36,
                          borderRadius: 8,
                          borderColor: "#dde3ef",
                        }),
                      }}
                    />
                  </div>
                  {/* Date Range */}
                  <div className="ord-filter-col-sm">
                    <label className="ord-filter-label">
                      Created Date Range
                    </label>
                    <DateRangePicker
                      value={dateRange}
                      onChange={setDateRange}
                      character=" – "
                    />
                  </div>
                </div>
              )}
            </div>

            {/* ── Table Card ── */}
            <div className="ord-table-card">
              <div className="ord-table-head">
                <div className="ord-table-title">
                  Order Records
                  <span className="ord-table-count">
                    ({total.toLocaleString("en-IN")})
                  </span>
                </div>
              </div>

              <div className="ord-table-scroll table-scroll">
                <Table striped className="shadow-sm rounded">
                  <TableHeader
                    classes={{ th: "bg-custom text-white sticky-header" }}
                  />
                  {body && Array.isArray(body) ? (
                    <TableBody />
                  ) : (
                    <tbody>
                      <tr>
                        <td
                          colSpan={100}
                          align="center"
                          style={{ padding: 40 }}
                        >
                          <Spinner />
                        </td>
                      </tr>
                    </tbody>
                  )}
                </Table>
              </div>

              <div className="ord-table-foot">
                <span className="ord-table-foot-text">
                  Total:{" "}
                  <strong style={{ color: "#1a1d23" }}>
                    {total.toLocaleString("en-IN")}
                  </strong>{" "}
                  records
                </span>
                <Pagination
                  classes={{
                    buttonGroup: "btn-custom",
                    button: "bg-custom border-white",
                  }}
                />
              </div>
            </div>
          </DatatableWrapper>
        </Container>

        {/* ════════════════════════════════════
            TRANSFER OWNER MODAL
        ════════════════════════════════════ */}
        {changeOwnerModal && (
          <Modal
            show={changeOwnerModal}
            onHide={handelChangeOwnerModalClose}
            size="xl"
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title
                style={{
                  fontFamily: "'Space Grotesk', sans-serif",
                  fontSize: 16,
                }}
              >
                Transfer Owner
              </Modal.Title>
            </Modal.Header>
            <Form onSubmit={ChangeOwner}>
              <Modal.Body>
                <Row className="gap-3">
                  <Col lg={12}>
                    <Row>
                      <Col lg={6} xs={12} className="mb-3 mb-lg-0">
                        <FormGroup>
                          <FormLabel style={{ fontSize: 12, fontWeight: 600 }}>
                            From
                          </FormLabel>
                          <Select
                            isClearable
                            options={users}
                            onChange={(e) => setFromUser(e || {})}
                            name="fromUser"
                            required
                            styles={{
                              control: (b) => ({
                                ...b,
                                fontSize: 12,
                                borderRadius: 8,
                                borderColor: "#dde3ef",
                              }),
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col lg={6} xs={12}>
                        <FormGroup>
                          <UserMultiSelect
                            options={users}
                            value={selectedToUsers}
                            onChange={setSelectedToUsers}
                            label="To"
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                {fromUser && Object.keys(fromUser).length > 0 && (
                  <Container
                    style={{ height: "50vh", overflowY: "auto", marginTop: 16 }}
                  >
                    {!spinnerForChangeOwner ? (
                      <DatatableWrapper
                        body={ownerLeads}
                        headers={ownerLeadsHeader}
                      >
                        <Table striped className="data-table" ref={tableRef}>
                          <TableHeader />
                          <TableBody />
                        </Table>
                      </DatatableWrapper>
                    ) : (
                      <div className="d-flex justify-content-center align-items-center mt-5">
                        <Spinner animation="border" variant="secondary" />
                      </div>
                    )}
                  </Container>
                )}
              </Modal.Body>
              <Modal.Footer>
                <Button variant="success" type="submit">
                  Change
                </Button>
                <Button onClick={handelChangeOwnerModalClose} variant="light">
                  Close
                </Button>
              </Modal.Footer>
            </Form>
          </Modal>
        )}
      </div>
    </>
  );
};

export default OrderList;
